import { useEffect, useState } from "react";

function useCountdown(target) {
  const [left, setLeft] = useState(target - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(target - Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);
  const clamp = Math.max(0, left);
  const h = String(Math.floor(clamp / 3.6e6)).padStart(2, "0");
  const m = String(Math.floor((clamp % 3.6e6) / 6e4)).padStart(2, "0");
  const s = String(Math.floor((clamp % 6e4) / 1000)).padStart(2, "0");
  return { h, m, s };
}

export default function Countdown({ hoursFromNow = 5, light = false, testId }) {
  const [target] = useState(() => {
    const stored = Number(localStorage.getItem("drelo_flash_end"));
    if (stored && stored > Date.now()) return stored;
    const t = Date.now() + hoursFromNow * 3.6e6;
    localStorage.setItem("drelo_flash_end", String(t));
    return t;
  });
  const { h, m, s } = useCountdown(target);
  const box = light
    ? "bg-white/20 text-white border-white/30"
    : "bg-drelo-urgency text-white border-drelo-urgency";
  return (
    <span className="inline-flex items-center gap-1 font-display font-bold tabular-nums" data-testid={testId}>
      {[h, m, s].map((v, i) => (
        <span key={i} className="contents">
          <span className={`px-2 py-1 rounded-md border ${box} text-sm`}>{v}</span>
          {i < 2 && <span className={light ? "text-white" : "text-drelo-urgency"}>:</span>}
        </span>
      ))}
    </span>
  );
}
